<template>
  <div>
    <TheHeader
      with-menu
      class="md:mb-8"
    />
    <BaseSection class="mb-10">
      <BaseTitleGroup
        :title="$t('Legal notice')"
        subtitle="KERALA"
        class="mb-8"
      />
      <BaseParagraph class="max-w-custom">
        <div class="font-medium text-black mb-2">
          {{ $t('Publisher') }}
        </div>
        <div
          class="mb-8"
          v-html="$t('LegalNoticeContent.Publisher')"
        />
        <div class="font-medium text-black mb-2">
          {{ $t('Hosting') }}
        </div>
        <div
          class="mb-8"
          v-html="$t('LegalNoticeContent.Hosting')"
        />
        <div class="font-medium text-black mb-2">
          {{ $t('General Information') }}
        </div>
        <div
          class="mb-8"
          v-html="$t('LegalNoticeContent.GeneralInformation')"
        />
        <div class="font-medium text-black mb-2">
          {{ $t('LegalAuthority') }}
        </div>
        <div
          class="mb-8"
          v-html="$t('LegalNoticeContent.LegalAuthority')"
        />
        <div class="font-medium text-black mb-2">
          {{ $t('AMFInformation') }}
        </div>
        <div
          class="mb-8"
          v-html="$t('LegalNoticeContent.AMFInformation')"
        />
        <div class="font-medium text-black mb-2">
          {{ $t('GDPR') }}
        </div>
        <div
          class="mb-8"
          v-html="$t('LegalNoticeContent.GDPR')"
        />
      </BaseParagraph>
    </BaseSection>
    <TheFooter />
  </div>
</template>

<script>
import TheHeader from '../components/TheHeader.vue';
import TheFooter from '../components/TheFooter.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseParagraph from '../components/BaseParagraph.vue';

export default {
  name: 'LegalNotice',
  components: {
    TheHeader,
    TheFooter,
    BaseTitleGroup,
    BaseSection,
    BaseParagraph,
  },
};
</script>

<style lang="css">
.max-w-custom {
  max-width: 720px;
}
</style>
